var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailOutline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 8.48364L8.89 13.7436C9.21866 13.9629 9.6049 14.0799 10 14.0799C10.3951 14.0799 10.7813 13.9629 11.11 13.7436L19 8.48364M3 19.4836H17C17.5304 19.4836 18.0391 19.2729 18.4142 18.8979C18.7893 18.5228 19 18.0141 19 17.4836V7.48364C19 6.95321 18.7893 6.4445 18.4142 6.06943C18.0391 5.69436 17.5304 5.48364 17 5.48364H3C2.46957 5.48364 1.96086 5.69436 1.58579 6.06943C1.21071 6.4445 1 6.95321 1 7.48364V17.4836C1 18.0141 1.21071 18.5228 1.58579 18.8979C1.96086 19.2729 2.46957 19.4836 3 19.4836Z",
    stroke: "#0B4725",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailOutline);
export default __webpack_public_path__ + "static/media/MailOutline.a85202adde964b1ac8ed4d44b0e5c9c2.svg";
export { ForwardRef as ReactComponent };